import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const Input = styled.input.attrs({
  type: "checkbox"
})`
  align-items: center;
  appearance: none;
  background: ${colors.foxGrey};
  border: none;
  border-radius: ${({ componentSize }) => 12 * componentSize}px;
  cursor: pointer;
  display: flex;
  height: ${({ componentSize }) => 25 * componentSize}px;
  margin: 0;
  padding: 0;
  transition: transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1),
    background 250ms ease-in-out;
  width: ${({ componentSize }) => 46 * componentSize}px;

  :disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  :before {
    content: "";
    border-radius: 50%;
    background: white;
    display: block;
    margin-left: ${({ componentSize }) => 2 * componentSize}px;
    width: ${({ componentSize }) => 21 * componentSize}px;
    height: ${({ componentSize }) => 21 * componentSize}px;
    box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
    transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1);
  }

  :checked {
    background: ${colors.primary};
  }

  :checked:before {
    box-shadow: -3px 0 5px 0 rgba(0, 0, 0, 0.2);
    transform: translateX(${({ componentSize }) => 21 * componentSize}px);
  }

  ${props => {
    if (props.withCheckIcon) {
      return css`
        background: ${colors.wolfGrey};
        border-radius: 100px;
        height: 26px;
        width: 43px;

        :before {
          box-shadow: none;
          margin-left: 1px;
          height: 24px;
          width: 24px;
        }

        :checked:before {
          box-shadow: none;
          transform: translateX(17px);
        }

        :after {
          color: ${colors.primary};
          content: "\f00c";
          display: block;
          font-family: FontAwesome;
          margin-left: -18px;
          opacity: 0;
          position: relative;
          transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1);
        }

        :checked:after {
          opacity: 1;
          transform: translateX(17px);
        }
      `;
    }

    return null;
  }}
`;
